@if (show) {
    <div class="modal confirm-modal fade" [class.show]="showModel" id="confirm-modal-warning" tabindex="-1" aria-labelledby="confirmation-modal"
        aria-modal="true" role="dialog" style="display: block; padding-left: 0px">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="close()"></button>
                <div class="modal-body">
                    <div class="confirm-modal-body">
                        <div class="warning-icon"></div>
                        <h2 id="confirmation-modal">{{alertInfo.title}}</h2>
                        <p>{{alertInfo.text}}</p>
                        @if(alertInfo.subtext){
                            <p>{{alertInfo.subtext}}</p>
                        }
                        <div class="confirm-buttons">
                            <button class="btn btn-primary w-100" (click)="close()"
                                id="confirmation-no-btn">Ok</button>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
}